import * as Yup from 'yup'
import { TFunction } from '_metronic/i18n/Metronici18n'
import {
  FORMATO_CODIGO_CAMPO,
  FORMATO_CODIGO_OPCAO,
  normalizarCodigoOpcao,
} from '../../../../core/condicao/codigoOpcao'

/**
 * Validação do modal de configuração de campo.
 *
 * O código do campo e o código de cada opção são opcionais (vazio = o backend gera), mas quando
 * preenchidos seguem o mesmo formato do backend. Um formato inválido bloqueia o Salvar.
 */
export const criarCamposSchema = (t: TFunction) =>
  Yup.object({
    rotulo: Yup.string()
      .required('Rotulo Obrigatório')
      .max(255, 'O rótulo deve ter no máximo 255 caracteres')
      .min(0, 'O rótulo não pode ser vazio'),
    instrucoes: Yup.string()
      .max(1024, 'O rótulo deve ter no máximo 1024 caracteres')
      .min(0, 'O rótulo não pode ser vazio'),
    codigo: Yup.string().test(
      'formato-codigo-campo',
      t('formularios.construtor.codigo.formato'),
      (valor) => !valor || FORMATO_CODIGO_CAMPO.test(valor)
    ),
    opcoes: Yup.array()
      .of(
        Yup.object({
          descricao: Yup.string(),
          codigo: Yup.string().test(
            'formato-codigo-opcao',
            t('formularios.construtor.opcao.codigo.formato'),
            (valor) => !valor || FORMATO_CODIGO_OPCAO.test(valor)
          ),
        })
      )
      .test(
        'codigos-opcao-unicos',
        t('formularios.construtor.opcao.codigo.duplicado'),
        (opcoes) => {
          const codigos = (opcoes ?? [])
            .map((opcao) => normalizarCodigoOpcao(opcao?.codigo))
            .filter((codigo) => codigo !== '')
          return new Set(codigos).size === codigos.length
        }
      ),
  })
